module.exports = __webpack_public_path__ + "52cf5f01fcc71abf4e2ab3e0737f4a5f.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/ic_location.svg
// module id = 1357
// module chunks = 73